import { ElementTypeDTO } from '@/model';

export const isTextElementType = (elementType: ElementTypeDTO) =>
  [
    ElementTypeDTO.CLOCK,
    ElementTypeDTO.TEXT_CONSTANT,
    ElementTypeDTO.TIME_COUNT_DOWN,
    ElementTypeDTO.STOP_NAME,
    ElementTypeDTO.STOP_DIRECTION_NAME,
    ElementTypeDTO.PAGE_COUNTER,
  ].includes(elementType);

export const isImageType = (elementType: ElementTypeDTO) => {
  return [ElementTypeDTO.IMAGE_DISPLAY_NORMAL, ElementTypeDTO.PAGER].includes(
    elementType,
  );
};

export const getMoveableElementId = (selector: string, id: number) => {
  return selector + '-' + id;
};
